(() => {
  const current = document.currentScript;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHeroCarousels = (root = document) => {
    const carousels = [];
    if (root instanceof Element && root.matches('[data-sok-carousel]')) carousels.push(root);
    root.querySelectorAll?.('[data-sok-carousel]').forEach((carousel) => carousels.push(carousel));

    carousels.forEach((carousel) => {
      if (carousel.dataset.sokCarouselReady === 'true') return;

      const slides = [...carousel.querySelectorAll('[data-sok-slide]')];
      const dots = [...carousel.querySelectorAll('[data-sok-dot]')];
      const pauseButton = carousel.querySelector('[data-sok-pause]');
      const track = carousel.querySelector('[data-sok-track]');
      if (!track || slides.length < 2) return;

      carousel.dataset.sokCarouselReady = 'true';
      carousel.dataset.autoplaySeconds = '5';

      let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let trackIndex = active + 1;
      let paused = reduceMotion;
      let timer = null;
      let pointerStart = null;
      const delay = 5000;

      const firstClone = slides[0].cloneNode(true);
      const lastClone = slides[slides.length - 1].cloneNode(true);
      [firstClone, lastClone].forEach((clone) => {
        clone.removeAttribute('data-sok-slide');
        clone.removeAttribute('id');
        clone.classList.remove('is-active');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      });
      track.prepend(lastClone);
      track.append(firstClone);
      track.style.transform = `translate3d(-${trackIndex * 100}%,0,0)`;

      const updatePauseButton = () => {
        if (!pauseButton) return;
        pauseButton.textContent = paused ? '▶' : 'Ⅱ';
        pauseButton.setAttribute('aria-label', paused ? 'Play carousel' : 'Pause carousel');
      };

      const restartAutoplay = () => {
        window.clearInterval(timer);
        timer = null;
        carousel.dataset.autoplayPaused = paused ? 'true' : 'false';
        if (!paused) timer = window.setInterval(() => moveBy(1), delay);
      };

      const render = () => {
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
          slide.toggleAttribute('inert', !selected);
        });
        dots.forEach((dot, index) => {
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        track.style.transform = `translate3d(-${trackIndex * 100}%,0,0)`;
        updatePauseButton();
        restartAutoplay();
      };

      const goTo = (next) => {
        active = (next + slides.length) % slides.length;
        trackIndex = active + 1;
        render();
      };

      function moveBy(distance) {
        if (distance > 0 && active === slides.length - 1) {
          active = 0;
          trackIndex = slides.length + 1;
        } else if (distance < 0 && active === 0) {
          active = slides.length - 1;
          trackIndex = 0;
        } else {
          active += distance;
          trackIndex = active + 1;
        }
        render();
      }

      track.addEventListener('transitionend', () => {
        if (trackIndex !== 0 && trackIndex !== slides.length + 1) return;
        track.classList.add('is-resetting');
        trackIndex = trackIndex === 0 ? slides.length : 1;
        track.style.transform = `translate3d(-${trackIndex * 100}%,0,0)`;
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => track.classList.remove('is-resetting')));
      });

      carousel.querySelector('[data-sok-prev]')?.addEventListener('click', () => moveBy(-1));
      carousel.querySelector('[data-sok-next]')?.addEventListener('click', () => moveBy(1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
      pauseButton?.addEventListener('click', () => {
        paused = !paused;
        updatePauseButton();
        restartAutoplay();
      });
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') moveBy(1);
        if (event.key === 'ArrowLeft') moveBy(-1);
        if (event.key === ' ') {
          event.preventDefault();
          paused = !paused;
          updatePauseButton();
          restartAutoplay();
        }
      });
      carousel.addEventListener('pointerdown', (event) => { pointerStart = event.clientX; });
      carousel.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        if (Math.abs(distance) > 55) moveBy(distance < 0 ? 1 : -1);
        pointerStart = null;
      });

      updatePauseButton();
      render();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeroCarousels(), { once: true });
  } else {
    initHeroCarousels();
  }
  document.addEventListener('shopify:section:load', (event) => initHeroCarousels(event.target));

  if (!document.getElementById('sok-engineering-body-type')) {
    const style = document.createElement('style');
    style.id = 'sok-engineering-body-type';
    style.textContent = `@media (min-width:750px){.sok-eng .sok-eng-card__content>p{font-size:13px!important;line-height:1.5!important}}`;
    document.head.appendChild(style);
  }

  if (!document.getElementById('sok-product-mobile-spacing')) {
    const productSpacing = document.createElement('style');
    productSpacing.id = 'sok-product-mobile-spacing';
    productSpacing.textContent = `@media (max-width:749px){product-info[id^="MainProduct-"] .product__media-wrapper + .product__info-wrapper{margin-top:1.8rem!important}}`;
    document.head.appendChild(productSpacing);
  }

  if (!document.getElementById('sok-product-section-gap')) {
    const productSectionGap = document.createElement('style');
    productSectionGap.id = 'sok-product-section-gap';
    productSectionGap.textContent = `product-info[id^="MainProduct-"]{padding-bottom:32px!important}@media (max-width:749px){product-info[id^="MainProduct-"]{padding-bottom:24px!important}}`;
    document.head.appendChild(productSectionGap);
  }

  const lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  const cartLabels = {
    de: 'In den Warenkorb',
    nl: 'In winkelwagen',
    sv: 'Lägg i kundvagn'
  };
  const cartLabel = cartLabels[lang];

  if (cartLabel) {
    if (!document.getElementById('sok-cart-cta-style')) {
      const ctaStyle = document.createElement('style');
      ctaStyle.id = 'sok-cart-cta-style';
      ctaStyle.textContent = `
        .product-form__submit,
        .quick-add__submit,
        .sok-local-add,
        .sok-product-sticky-actions button,
        .sok-product-sticky-actions .sok-local-button,
        [data-sok-cart-cta] {
          white-space: nowrap !important;
          font-weight: 800 !important;
          letter-spacing: .01em !important;
        }
        .product-form__submit > span,
        .quick-add__submit > span,
        .sok-local-add > span,
        .sok-product-sticky-actions button > span,
        .sok-product-sticky-actions .sok-local-button > span {
          white-space: nowrap !important;
        }
      `;
      document.head.appendChild(ctaStyle);
    }

    const knownLabels = new Set([
      'Add to cart',
      'In den Warenkorb legen',
      'In den Warenkorb',
      'Aan winkelwagen toevoegen',
      'In winkelwagen',
      'Lägg i varukorgen',
      'Lägg i kundvagn'
    ]);

    const ctaSelector = [
      '.product-form__submit',
      '.quick-add__submit',
      '.sok-local-add',
      '.sok-product-sticky-actions button',
      '.sok-product-sticky-actions .sok-local-button',
      '[data-sok-cart-cta]'
    ].join(',');

    const updateButton = (button) => {
      if (!(button instanceof HTMLElement) || button.disabled) return;
      const span = button.querySelector('span:not(.loading__spinner):not(.sold-out-message)');
      const target = span || button;
      const text = (target.textContent || '').replace(/\s+/g, ' ').trim();
      if (knownLabels.has(text)) target.textContent = cartLabel;
    };

    const updateCTAs = (root = document) => {
      if (root instanceof Element && root.matches(ctaSelector)) updateButton(root);
      root.querySelectorAll?.(ctaSelector).forEach(updateButton);
      if (window.variantStrings) window.variantStrings.addToCart = cartLabel;
    };

    const startCTAObserver = () => {
      updateCTAs();
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'characterData') {
            const parent = mutation.target.parentElement?.closest(ctaSelector);
            if (parent) updateButton(parent);
            return;
          }
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) updateCTAs(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startCTAObserver, { once: true });
    } else {
      startCTAObserver();
    }
  }

  if (!current?.src) return;
  const source = new URL(current.src);
  source.pathname = source.pathname.replace(/sok-theme\.js$/, 'refine-sok-theme.js');

  const refine = document.createElement('script');
  refine.src = source.toString();
  refine.async = true;
  document.head.appendChild(refine);
})();

;(() => {
  const productRootSelector = 'product-info[id^="MainProduct-"]';
  const heavyProductHandles = new Set([
    'sk12v314ph-sok-12v-314ah-lifepo4-battery',
    'sk24v150ph-sok-24v-150ah-lifepo4-battery',
    'sk48v100n-sok-48v-100ah-lifepo4-battery'
  ]);

  const getProductHandle = () => {
    const marker = '/products/';
    const path = window.location.pathname;
    if (!path.includes(marker)) return '';
    return (path.split(marker)[1] || '').split('/')[0].split('?')[0];
  };

  const ensureHeavyShippingStyle = () => {
    if (document.getElementById('sok-heavy-shipping-notice-style')) return;
    const style = document.createElement('style');
    style.id = 'sok-heavy-shipping-notice-style';
    style.textContent = `
      ${productRootSelector} .sok-heavy-shipping-notice {
        display: flex !important;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: .45rem .65rem;
        margin: 1.15rem 0 0 !important;
        padding: 1.15rem 1.35rem !important;
        border: .1rem solid rgba(204,32,36,.24);
        border-left: .4rem solid #CC2024;
        border-radius: .8rem;
        background: #fff6f6;
        color: #292929;
        font-size: 1.35rem !important;
        line-height: 1.45;
        letter-spacing: .01em;
      }
      ${productRootSelector} .sok-heavy-shipping-notice strong {
        color: #CC2024;
        font-weight: 850;
      }
      ${productRootSelector} .sok-heavy-shipping-notice span {
        color: #292929;
      }
      ${productRootSelector} .sok-non-eu-shipping-note {
        display: none !important;
      }
      @media (max-width: 749px) {
        ${productRootSelector} .sok-heavy-shipping-notice {
          margin-top: 1rem !important;
          padding: 1rem 1.15rem !important;
          font-size: 1.25rem !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const applyShippingMessage = () => {
    const productRoot = document.querySelector(productRootSelector);
    if (!productRoot) return;
    const taxLine = productRoot.querySelector('.product__tax');
    if (!taxLine || taxLine.dataset.sokShippingProcessed === 'true') return;

    const isHeavyProduct = heavyProductHandles.has(getProductHandle());
    if (!isHeavyProduct) {
      taxLine.remove();
      return;
    }

    ensureHeavyShippingStyle();
    taxLine.dataset.sokShippingProcessed = 'true';
    taxLine.className = 'product__tax sok-heavy-shipping-notice';
    taxLine.setAttribute('role', 'note');
    taxLine.setAttribute('aria-label', 'Non-EU shipping requirement');
    taxLine.replaceChildren();

    const label = document.createElement('strong');
    label.textContent = 'Non-EU Region:';
    const message = document.createElement('span');
    message.textContent = 'This product is available for shipping with orders of 4 units (120 kg+) or more.';
    taxLine.append(label, message);
  };

  const startShippingObserver = () => {
    applyShippingMessage();
    const productRoot = document.querySelector(productRootSelector);
    if (!productRoot || productRoot.dataset.sokShippingObserver === 'true') return;
    productRoot.dataset.sokShippingObserver = 'true';
    const observer = new MutationObserver(() => window.requestAnimationFrame(applyShippingMessage));
    observer.observe(productRoot, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startShippingObserver, { once: true });
  } else {
    startShippingObserver();
  }
  document.addEventListener('shopify:section:load', startShippingObserver);
  document.addEventListener('variant:change', applyShippingMessage);
})();
